import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ProspectCustomerTableHeader from './ProspectCustomerTableHeader';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search } from 'services/salesperson-kpi/prospectCustomerService';
import PageHeader from 'components/common/PageHeader';
import ProspectCustomerTable from './ProspectCustomerTable';
import ProspectCustomerModal from './ProspectCustomerModal';
import { usePaginationBe } from 'hooks/useBeHandle';
import PropTypes from 'prop-types';
import ProspectCustomerFilter from './ProspectCustomerFilter';
import { joinDataMultiDropdown } from 'helpers/dropdownFuncHelper';

const ProspectCustomerDashboard = ({
  page = 1,
  size = 12,
  isFromManagerPage = false
}) => {
  const defaultRQ = { ...new BaseTableRQ(page, size), isFromManagerPage };
  const [sections, setProspectCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState({});
  const [isFilter, setIsFilter] = useState(false);
  const [filter, setFilter] = useState({});
  console.log(isFromManagerPage);
  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };
  const addNew = () => {
    setIsModal(true);
    setDataModal(null);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setDataModal(null);
  };
  const handleSubmitModal = () => {
    handleCloseModal();
    loadProspectCustomers(defaultRQ);
  };

  useEffect(() => {
    loadProspectCustomers(defaultRQ);
  }, []);

  const loadProspectCustomers = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setProspectCustomers(res.items);
          setTotal(res.total);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    paging,
    total,
    loadProspectCustomers
  );

  const handleChange = (field, value) => {
    console.log(field, value);
    setFilter({
      ...filter,
      [field]: value
    });
  };

  const handleFilterSubmit = () => {
    let rq = mapRQData(filter);
    loadProspectCustomers({ ...defaultRQ, ...rq });
  };

  const mapRQData = data => {
    if (data) {
      let mapRq = { ...data };
      // if (data?.date && data?.date instanceof Date) {
      //   mapRq.targetDate = data?.date?.toISOString();
      // }
      console.log(data);
      mapRq.customerType = data?.customerType?.value;
      mapRq.createdBy = joinDataMultiDropdown(data?.createdBy);
      return mapRq;
    }
    return null;
  };

  console.log(isFilter, isFromManagerPage);
  return (
    <>
      <PageHeader
        title="Add prospect"
        description={`Manage and view your available Add prospect.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <ProspectCustomerTableHeader
                toggelFilter={() => toggelFilter()}
                toggelModal={() => addNew()}
                handleSearch={handleFilterSubmit}
                style={{ padding: '10px' }}
                isFromManagerPage={isFromManagerPage}
              />
              {isFilter && isFromManagerPage && (
                <Col
                  lg={12}
                  style={{
                    padding: '17px',
                    paddingTop: '8px',
                    paddingBottom: '8px'
                  }}
                >
                  <ProspectCustomerFilter
                    displayOption={{
                      showHeader: true,
                      showFooter: true,
                      col: '6'
                    }}
                    style={{
                      paddingBottom: '10px',
                      maxHeight: '250px',
                      overflowY: 'auto'
                    }}
                    handleChange={handleChange}
                    formData={filter}
                    handleSubmit={handleFilterSubmit}
                  />
                </Col>
              )}
              <ProspectCustomerTable
                data={sections}
                paging={paging}
                total={total}
                nextPage={nextPage}
                previousPage={previousPage}
                gotoPage={gotoPage}
                rowClassName={'clickable'}
                handleClickRow={row => {
                  if (row) {
                    console.log(row);
                    setDataModal(row.original);
                    setIsModal(true);
                  }
                }}
                isFromManagerPage={isFromManagerPage}
              />
            </Row>
          </Card>
        </Col>
      </Row>
      {!isFromManagerPage && (
        <ProspectCustomerModal
          isShow={isModal}
          handleClose={handleCloseModal}
          data={dataModal}
          handleSubmit={handleSubmitModal}
        />
      )}
    </>
  );
};

ProspectCustomerDashboard.propTypes = {
  page: PropTypes.number,
  size: PropTypes.number,
  isFromManagerPage: PropTypes.bool
};

export default ProspectCustomerDashboard;
